import { resourceTypeShortNames } from "./resourceTypeShortNames";
import { ResourceType } from "../../../../services/cloudchipr.api";

export const resourceServiceShortNames: Map<
  ResourceType,
  { singular: string; plural: string }
> = new Map([
  ...Array.from(resourceTypeShortNames),
  ["ec2", { singular: "EC2", plural: "EC2" }],
  ["rds", { singular: "RDS", plural: "RDS" }],
  ["eks", { singular: "EKS", plural: "EKS" }],
  ["vm", { singular: "GCE", plural: "GCE" }],
  ["ip", { singular: "Network", plural: "Networks" }],
  ["dynamo_db_table", { singular: "DynamoDB", plural: "DynamoDB" }],
  ["nat_gateway", { singular: "VPC", plural: "VPC" }],
  ["ecs", { singular: "ECS", plural: "ECS" }],
]);
